import React from 'react'
import { observer } from 'mobx-react'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import MenuItem from 'widgets/navigation/MenuItem'
import MenuItems from 'widgets/navigation/MenuItems'
import { useAuth } from '@morningtrain/react-auth'

function EconomyMenuItems () {
  const auth = useAuth()

  if (
    !auth.can('app.economy.revenue') &&
    !auth.can('app.economy.avg_basket_size') &&
    !auth.can('app.economy.guest_count') &&
    !auth.can('app.economy.salary_percentage') &&
    !auth.can('app.economy.goodsusage') &&
    !auth.can('app.economy.discounts')
  ) {
    return (
      <MenuItem
        label={<Translation name='economy.title' />}
        route='app.economy.overview'
        svgIcon={<Icons.PieChart />}
      />
    )
  }

  return (
    <MenuItems
      label={<Translation name='economy.title' />}
      svgIcon={<Icons.PieChart />}
    >
      <MenuItem
        route='app.economy.overview'
        label={<Translation name='economy.pages.overview.title' />}
      />
      <MenuItem
        route='app.economy.revenue'
        linkProps={{ disableRouting: true }}
        label={<Translation name='economy.pages.revenue.title' />}
      />
      <MenuItem
        route='app.economy.avg_basket_size'
        label={<Translation name='economy.pages.avg_basket_size.title' />}
      />
      <MenuItem
        route='app.economy.guest_count'
        label={<Translation name='economy.pages.guest_count.title' />}
      />
      <MenuItem
        route='app.economy.salary_percentage'
        label={<Translation name='economy.pages.wage_ratio.title' />}
      />
      <MenuItem
        route='app.economy.goodsusage'
        label={<Translation name='economy.pages.goodsusage.title' />}
      />
      <MenuItem
        route='app.economy.discounts'
        label={<Translation name='economy.pages.discounts.title' />}
      />
    </MenuItems>
  )
}

export default observer(EconomyMenuItems)
